import LegalLayout from "./LegalLayout";
import { PRIVACY_VERSION, ORG_INFO } from "./legalMeta";

export default function PrivacyPage() {
  return (
    <LegalLayout
      title="Política de Privacidad y Tratamiento de Datos Personales"
      version={PRIVACY_VERSION}
    >
      <p>
        En cumplimiento de la <strong>Ley 1581 de 2012</strong>, el{" "}
        <strong>Decreto 1377 de 2013</strong>, el{" "}
        <strong>Decreto 1074 de 2015</strong> y demás normas concordantes de la{" "}
        {ORG_INFO.jurisdiction} sobre protección de datos personales (Habeas
        Data), {ORG_INFO.developer} y la {ORG_INFO.clientShort} ponen en
        conocimiento de los Titulares de los datos la presente Política.
      </p>

      <h2>1. Responsable del Tratamiento</h2>
      <ul>
        <li>
          <strong>Responsable:</strong> {ORG_INFO.client}
        </li>
        <li>
          <strong>Encargado técnico:</strong> {ORG_INFO.developer} (desarrollo,
          hosting y soporte técnico de la Plataforma {ORG_INFO.product}).
        </li>
        <li>
          <strong>Correo de contacto para asuntos de privacidad:</strong>{" "}
          <a href={`mailto:${ORG_INFO.privacyEmail}`}>
            {ORG_INFO.privacyEmail}
          </a>
        </li>
      </ul>

      <h2>2. Datos que Recolectamos</h2>
      <h3>2.1 Datos de identificación</h3>
      <ul>
        <li>Nombres y apellidos</li>
        <li>Tipo y número de documento de identidad</li>
        <li>Fecha de nacimiento, género</li>
        <li>Dirección, ciudad, departamento</li>
        <li>Correo electrónico y teléfonos de contacto</li>
        <li>Fotografía personal (carnet, perfil)</li>
      </ul>

      <h3>2.2 Datos sensibles (Art. 5 Ley 1581/2012)</h3>
      <p>
        Algunos datos pueden considerarse sensibles, como:{" "}
        <strong>fotografías</strong>, datos de salud (alergias, condiciones
        médicas relevantes para actividades del club) e información sobre
        creencias religiosas (membresía en la Iglesia Adventista). Su
        tratamiento es <strong>facultativo</strong> y requiere autorización
        expresa del Titular o de su representante legal cuando se trate de
        menores de edad.
      </p>

      <h3>2.3 Datos de actividad</h3>
      <ul>
        <li>Asistencia a eventos, reuniones y actividades</li>
        <li>Progreso en clases, requisitos y especialidades</li>
        <li>Pagos y registros de inscripción a eventos</li>
        <li>Documentos de soporte (consentimientos, autorizaciones)</li>
      </ul>

      <h3>2.4 Datos técnicos</h3>
      <ul>
        <li>Dirección IP, navegador, sistema operativo</li>
        <li>Logs de acceso y eventos de seguridad</li>
        <li>
          Cookies estrictamente necesarias para el funcionamiento (sesión,
          preferencias)
        </li>
      </ul>

      <h2>3. Finalidades del Tratamiento</h2>
      <ul>
        <li>Gestionar la membresía y las actividades de los clubes.</li>
        <li>
          Llevar registros de asistencia, progreso, investiduras y eventos.
        </li>
        <li>Procesar inscripciones y pagos a eventos.</li>
        <li>
          Comunicar información relevante (notificaciones de eventos,
          recordatorios, autorizaciones).
        </li>
        <li>
          Cumplir obligaciones legales, contables y de reporte ante autoridades
          eclesiásticas y civiles.
        </li>
        <li>
          Generar estadísticas anonimizadas para mejorar la operación de la
          Plataforma.
        </li>
        <li>
          Garantizar la seguridad de la Plataforma y prevenir fraudes o accesos
          no autorizados.
        </li>
      </ul>

      <h2>4. Datos de Menores de Edad</h2>
      <p>
        Conforme al artículo 7 de la Ley 1581/2012 y la Sentencia C-748/2011 de
        la Corte Constitucional, el tratamiento de datos de menores requiere:
      </p>
      <ul>
        <li>
          Autorización expresa, previa e informada de los padres o
          representantes legales.
        </li>
        <li>
          Respeto al interés superior del menor y a sus derechos fundamentales.
        </li>
        <li>
          Considerar la opinión del menor según su madurez, autonomía y
          capacidad de entendimiento.
        </li>
      </ul>

      <h2>5. Derechos del Titular</h2>
      <p>Como Titular de los datos, usted tiene derecho a:</p>
      <ul>
        <li>
          <strong>Conocer, actualizar y rectificar</strong> sus datos
          personales.
        </li>
        <li>
          <strong>Solicitar prueba</strong> de la autorización otorgada.
        </li>
        <li>
          <strong>Ser informado</strong> sobre el uso dado a sus datos.
        </li>
        <li>
          <strong>Presentar quejas</strong> ante la Superintendencia de
          Industria y Comercio (SIC) por infracciones a la normativa.
        </li>
        <li>
          <strong>Revocar la autorización</strong> y/o solicitar la supresión de
          sus datos cuando no exista deber legal o contractual que obligue a
          conservarlos.
        </li>
        <li>
          <strong>Acceder gratuitamente</strong> a sus datos.
        </li>
      </ul>

      <h2>6. Procedimiento para Ejercer sus Derechos</h2>
      <p>
        Las consultas y reclamos podrán ser presentados al correo{" "}
        <a href={`mailto:${ORG_INFO.privacyEmail}`}>{ORG_INFO.privacyEmail}</a>{" "}
        indicando: nombre completo, documento de identidad, descripción del
        hecho, dirección de notificación y los documentos que soporten la
        solicitud. Plazos de respuesta:
      </p>
      <ul>
        <li>
          <strong>Consultas:</strong> diez (10) días hábiles, prorrogables por
          cinco (5) días hábiles más.
        </li>
        <li>
          <strong>Reclamos:</strong> quince (15) días hábiles, prorrogables por
          ocho (8) días hábiles más.
        </li>
      </ul>

      <h2>7. Medidas de Seguridad</h2>
      <p>
        Implementamos medidas técnicas, humanas y administrativas razonables
        para proteger los datos contra adulteración, pérdida, consulta, uso o
        acceso no autorizado, incluyendo:
      </p>
      <ul>
        <li>
          Cifrado en tránsito mediante <strong>TLS 1.2+</strong> (HTTPS).
        </li>
        <li>
          Cifrado del lado del cliente con <strong>AES-256-GCM</strong> para
          archivos sensibles (documentos de identidad, autorizaciones).
        </li>
        <li>
          Autenticación con verificación de correo electrónico y, donde aplique,
          segundo factor.
        </li>
        <li>
          Control de acceso basado en roles (RBAC) y reglas de seguridad de
          Firestore/Storage.
        </li>
        <li>
          Almacenamiento en{" "}
          <strong>Google Firebase / Google Cloud Platform</strong>, con
          certificaciones{" "}
          <strong>ISO 27001, ISO 27017, ISO 27018, SOC 1/2/3</strong> y
          compatibilidad con GDPR.
        </li>
        <li>
          Registro de auditoría de eventos críticos y reglas de seguridad
          estrictas.
        </li>
        <li>
          Backups periódicos y políticas de retención conforme a la finalidad
          del tratamiento.
        </li>
      </ul>

      <h2>8. Transferencia y Transmisión Internacional</h2>
      <p>
        Los datos pueden ser almacenados en servidores de Google Cloud Platform
        ubicados fuera de Colombia (principalmente Estados Unidos y otros países
        donde Google opere). Google cumple con marcos internacionales de
        protección de datos (GDPR, Privacy Shield sucesor, cláusulas
        contractuales tipo). Al aceptar esta Política, usted autoriza
        expresamente dicha transferencia.
      </p>

      <h2>9. Conservación de los Datos</h2>
      <p>
        Los datos se conservarán mientras dure la relación con el club o la
        Asociación, o por el tiempo necesario para cumplir obligaciones legales,
        fiscales o de defensa de derechos. Una vez cesen estas finalidades, los
        datos serán suprimidos o anonimizados.
      </p>

      <h2>10. Cookies</h2>
      <p>
        La Plataforma utiliza cookies estrictamente necesarias para mantener la
        sesión y el funcionamiento técnico. No utilizamos cookies de publicidad
        ni de tracking de terceros con fines comerciales.
      </p>

      <h2>11. Vigencia y Modificaciones</h2>
      <p>
        Esta Política rige a partir de su publicación. Cualquier cambio
        sustancial será comunicado por correo electrónico y publicado en la
        Plataforma. La base de datos tendrá vigencia indefinida mientras se
        mantengan las finalidades del tratamiento.
      </p>

      <h2>12. Autoridad de Control</h2>
      <p>
        El Titular podrá presentar quejas o reclamos ante la{" "}
        <strong>
          Superintendencia de Industria y Comercio (SIC) - Delegatura para la
          Protección de Datos Personales
        </strong>
        , en los términos de la Ley 1581 de 2012.
      </p>

      <h2>13. Aceptación</h2>
      <p>
        Al marcar la casilla de aceptación durante el registro, el Titular
        declara haber leído, comprendido y aceptado expresamente esta Política y
        autoriza el tratamiento de sus datos personales en los términos aquí
        descritos.
      </p>
    </LegalLayout>
  );
}
